// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-container-zkpxF {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0px;
  right: 0px;
  left: 0px;
  bottom: 0px;
  z-index: 3;
}

.modal-overlay-HluUM {
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: rgba(00, 00, 00, 0.27);
}

.modal-card-YgfNP {
  width: 288px;
  min-height: 300px;
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: var(--large-border-radius);
  box-shadow: 0px 2px 12px gray;
  z-index: 1;
}

.modal-overlayEnterAnimation_appear-T7VFT {
  opacity: 0;
}

.modal-overlayEnterAnimation_appearActive-i1K_8 {
  transition: all 180ms;
  opacity: 1;
}

.modal-overlayExitAnimation_exit-_maWs {
  opacity: 1;
}

.modal-overlayExitAnimation_exitActive-IkStE {
  transition: all 180ms;
  opacity: 0;
}

.modal-cardAnimation_appear-dMowg {
  opacity: 0.5;
  transform: scale(0.9);
}

.modal-cardAnimation_appearActive-w3Jih {
  transition: all 180ms ease-out;
  transform: scale(1);
  opacity: 1;
}

.modal-cardAnimation_exit-eZskx {
  opacity: 1;
  transform: scale(1);
  box-shadow: none;
}

.modal-cardAnimation_exitActive-BJSxF {
  transition: all 180ms ease-in;
  opacity: 0;
  transform: scale(0.9);
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/modal/modal.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,UAAU;EACV,SAAS;EACT,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,yCAAyC;EACzC,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,UAAU;EACV,qBAAqB;AACvB","sourcesContent":[".container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: fixed;\n  top: 0px;\n  right: 0px;\n  left: 0px;\n  bottom: 0px;\n  z-index: 3;\n}\n\n.overlay {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  background-color: rgba(00, 00, 00, 0.27);\n}\n\n.card {\n  width: 288px;\n  min-height: 300px;\n  display: flex;\n  flex-direction: column;\n  background-color: white;\n  border-radius: var(--large-border-radius);\n  box-shadow: 0px 2px 12px gray;\n  z-index: 1;\n}\n\n.overlayEnterAnimation_appear {\n  opacity: 0;\n}\n\n.overlayEnterAnimation_appearActive {\n  transition: all 180ms;\n  opacity: 1;\n}\n\n.overlayExitAnimation_exit {\n  opacity: 1;\n}\n\n.overlayExitAnimation_exitActive {\n  transition: all 180ms;\n  opacity: 0;\n}\n\n.cardAnimation_appear {\n  opacity: 0.5;\n  transform: scale(0.9);\n}\n\n.cardAnimation_appearActive {\n  transition: all 180ms ease-out;\n  transform: scale(1);\n  opacity: 1;\n}\n\n.cardAnimation_exit {\n  opacity: 1;\n  transform: scale(1);\n  box-shadow: none;\n}\n\n.cardAnimation_exitActive {\n  transition: all 180ms ease-in;\n  opacity: 0;\n  transform: scale(0.9);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `modal-container-zkpxF`,
	"overlay": `modal-overlay-HluUM`,
	"card": `modal-card-YgfNP`,
	"overlayEnterAnimation_appear": `modal-overlayEnterAnimation_appear-T7VFT`,
	"overlayEnterAnimation_appearActive": `modal-overlayEnterAnimation_appearActive-i1K_8`,
	"overlayExitAnimation_exit": `modal-overlayExitAnimation_exit-_maWs`,
	"overlayExitAnimation_exitActive": `modal-overlayExitAnimation_exitActive-IkStE`,
	"cardAnimation_appear": `modal-cardAnimation_appear-dMowg`,
	"cardAnimation_appearActive": `modal-cardAnimation_appearActive-w3Jih`,
	"cardAnimation_exit": `modal-cardAnimation_exit-eZskx`,
	"cardAnimation_exitActive": `modal-cardAnimation_exitActive-BJSxF`
};
export default ___CSS_LOADER_EXPORT___;
